import { DefectV10 } from './defectV10';
import { FlatRateUnitV10 } from './flatRateUnitV10';
import { PackageV10 } from './packageV10';
import { PartV10 } from './partV10';
export class JobV10 {
    static constructFromPlainObject(sourceJob) {
        const defects = sourceJob.defects ? sourceJob.defects.map((d) => DefectV10.constructFromPlainObject(d)) : [];
        const flatRateUnits = sourceJob.flatRateUnits
            ? sourceJob.flatRateUnits.map((f) => FlatRateUnitV10.constructFromPlainObject(f))
            : [];
        const parts = sourceJob.parts ? sourceJob.parts.map((p) => PartV10.constructFromPlainObject(p)) : [];
        const packages = sourceJob.packages
            ? sourceJob.packages.map((pck) => PackageV10.constructFromPlainObject(pck))
            : [];
        const job = new JobV10(sourceJob.title, sourceJob.comment, sourceJob.customerStatement, defects, flatRateUnits, parts, packages);
        job.externalId = sourceJob.externalId;
        job.demandCategory = sourceJob.demandCategory;
        job.demandId = sourceJob.demandId;
        job.positionNumber = sourceJob.positionNumber;
        job.setSelected(!!sourceJob.selected);
        return job;
    }
    constructor(title, comment, customerStatement, defects = [], flatRateUnits = [], parts = [], packages = []) {
        this.title = title;
        this.comment = comment;
        this.customerStatement = customerStatement;
        this.defects = defects;
        this.flatRateUnits = flatRateUnits;
        this.parts = parts;
        this.packages = packages;
        this.selected = false;
    }
    getExternalId() {
        return this.externalId;
    }
    setExternalId(externalId) {
        this.externalId = externalId;
    }
    getDemandCategory() {
        return this.demandCategory;
    }
    setDemandCategory(demandCategory) {
        this.demandCategory = demandCategory;
    }
    getDemandId() {
        return this.demandId;
    }
    setDemandId(demandId) {
        this.demandId = demandId;
    }
    getPositionNumber() {
        return this.positionNumber;
    }
    setPositionNumber(positionNumber) {
        this.positionNumber = positionNumber;
    }
    getTitle() {
        return this.title;
    }
    setTitle(title) {
        this.title = title;
    }
    getComment() {
        return this.comment;
    }
    setComment(comment) {
        this.comment = comment;
    }
    getCustomerStatement() {
        return this.customerStatement;
    }
    setCustomerStatement(customerStatement) {
        this.customerStatement = customerStatement;
    }
    getDefects() {
        return this.defects;
    }
    getFlatRateUnits() {
        return this.flatRateUnits;
    }
    getPackages() {
        return this.packages;
    }
    getParts() {
        return this.parts;
    }
    isSelected() {
        return this.selected;
    }
    setSelected(selected) {
        this.selected = selected;
    }
}
//# sourceMappingURL=jobV10.js.map